import { browserProfilingIntegration } from '@sentry/browser';

export const browserProfiling = browserProfilingIntegration();
